import { render, staticRenderFns } from "./FormElementUpload.vue?vue&type=template&id=2bd88275&scoped=true&"
import script from "./FormElementUpload.vue?vue&type=script&lang=js&"
export * from "./FormElementUpload.vue?vue&type=script&lang=js&"
import style0 from "./FormElementUpload.vue?vue&type=style&index=0&id=2bd88275&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd88275",
  null
  
)

export default component.exports